import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarEmpreendimentosAdmin() {
  const fetchData = async () => {
    const LISTAR_EMPREENDIMENTOS = `locais/admin/empreendimentos/v1`;
    const response = await instance.get(LISTAR_EMPREENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_empreendimentos_admin"],
    refetchOnMount: false,
    enabled: false,
  });
  return query;
}
